import { createBrowserRouter, Navigate } from "react-router-dom";
import { Login } from "../pages/Login";
import { isAuthenticated, isRepresentante, shouldHideFeeDetails } from "../libs/auth";
import { Pdv } from "../pages/Pdv";
import { Pagamento } from "../pages/Pagamento";
import { PagamentoLinkWebpag } from "../pages/Pagamento/PagamentoLinkWebpag";
import { PagamentoPos } from "../pages/Pagamento/PagamentoPos";
import { CompraFinalizada } from "../pages/CompraFinalizada";
import { PagamentoFaturaFinalizado } from "../pages/Faturas/PagamentoFaturaFinalizado";
import { Pedidos } from "../pages/Pedidos";
import { DetalhePedido } from "../pages/DetalhePedido";
import { Faturas } from "../pages/Faturas";
import { Usuarios } from "../pages/Usuarios";
import { UsuarioEditar } from "../pages/UsuarioEditar";
import { UsuarioNovo } from "../pages/UsuarioNovo";
import { Movimentacao } from "../pages/Movimentacao";
import ErrorFallback from "../pages/ErrorFallback";
import { AgenciasAfiliadas } from "../pages/AgenciasAfiliadas";
import { VoucherInformacoesGerais } from "../pages/VoucherInformacoesGerais";

type PrivateRouteProps = {
  Component: React.FC;
  allowRepresentante?: boolean;
  allowHiddenFeesUser?: boolean;
  representanteOnly?: boolean;
};

const PrivateRoute = ({ Component, allowRepresentante = true, allowHiddenFeesUser = true, representanteOnly = false }: PrivateRouteProps) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  if (representanteOnly && !isRepresentante()) {
    return <Navigate to="/" />;
  }

  if (isRepresentante() && !allowRepresentante) {
    return <Navigate to="/" />;
  }

  if (shouldHideFeeDetails() && !allowHiddenFeesUser) {
    return <Navigate to="/" />;
  }

  return <Component />;
};

export const router = createBrowserRouter([
  {
    path: '/voucher/informacoes-gerais',
    element: <VoucherInformacoesGerais />,
  },
  {
    path: '/',
    errorElement: <ErrorFallback />,
    element: (
        <PrivateRoute Component={Pdv} />
    ),
    children: [

    ]
  },
  {
    path: '/pagamento/:id',
    element: (
        <PrivateRoute Component={Pagamento} allowRepresentante />
    ),
  },
  {
    path: '/pagamento/:id/link-webpag',
    element: (
        <PrivateRoute Component={PagamentoLinkWebpag} allowRepresentante />
    ),
  },
  {
    path: '/pagamento/:id/pos',
    element: (
        <PrivateRoute Component={PagamentoPos} allowRepresentante />
    ),
  },
  {
    path: '/finalizada/:id',
    element: (
        <PrivateRoute Component={CompraFinalizada} allowRepresentante />
    ),
  },
  {
    path: '/fatura-finalizada/:id',
    element: (
      <PrivateRoute Component={PagamentoFaturaFinalizado} allowRepresentante={false} allowHiddenFeesUser={false} />
    ),
  },
  {
    path: '/pedido/:id',
    element: isRepresentante()
      ? <Navigate to="/relatorio" />
      : <PrivateRoute Component={DetalhePedido} />,
  },
  {
    path: '/relatorio',
    element: (
        <PrivateRoute Component={Pedidos} />
    ),
  },
  {
    path: '/agencias-afiliadas',
    element: (
      <PrivateRoute Component={AgenciasAfiliadas} representanteOnly />
    ),
  },
  {
    path: '/faturas',
    element: (
      <PrivateRoute Component={Faturas} allowRepresentante={false} allowHiddenFeesUser={false} />
    ),
  },
  {
    path: '/usuarios',
    element: (
      <PrivateRoute Component={Usuarios} allowRepresentante={false} allowHiddenFeesUser={false} />
    ),
  },
  {
    path: '/usuario/:id',
    element: (
      <PrivateRoute Component={UsuarioEditar} allowRepresentante={false} allowHiddenFeesUser={false} />
    ),
  },
  {
    path: '/usuario/novo',
    element: (
      <PrivateRoute Component={UsuarioNovo} allowRepresentante={false} allowHiddenFeesUser={false} />
    ),
  },
  {
    path: '/movimentacao',
    element: (
      <PrivateRoute Component={Movimentacao} allowRepresentante={false} allowHiddenFeesUser={false} />
    ),
  },
  {
    path: "/login",
    element: <Login /> 
  },
])
